import ManagerRepository from 'coreClasses/ManagerRepository';
import {ProductItem} from 'coreStore/data/basket/types';
import CartProductItemModel from './CartProductItemModel';

interface ICartInfoBasket {
	itemsCount?: number;
	orderTotal?: number;
	productTotal?: number;
	productItems?: ProductItem[];
}

/**
 * Represents CartInfoModel
 */
export default class CartInfoModel {
	public cartQuantity: number;
	public cartValue: number;
	public cartProducts: CartProductItemModel[];

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {object} basket - basket
	 */
	constructor(managerRepository: ManagerRepository, basket: ICartInfoBasket) {
		this.cartQuantity = basket.itemsCount;
		this.cartValue = basket.orderTotal || basket.productTotal;
		this.cartProducts = basket.productItems?.map((productItem) => {
			return {...new CartProductItemModel(managerRepository, productItem)};
		});
	}
};
